

























import {
  Vue,
  Component,
} from "@/shared/vuepack";

import {
  PossibleExpense,
  ExpenseRecurringType,
  ExpenseCategory,
  ExpenseEligibility
} from "@/shared/types";

import EditExpenseForm from "@/shared/components/expense/EditExpenseForm.vue";
import Widget from "@/shared/components/Widget.vue";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    EditExpenseForm,
    Widget,
    Button
  }
})
export default class HealthcareExpensesAdd extends Vue {

  ExpenseEligibility = ExpenseEligibility;

  expense = {
    id: 0,
    name: "",
    amount: 0,
    comment: "",
    expensePaid: false,
    recurringType: ExpenseRecurringType.OneTime,
    expenseStatus: ExpenseEligibility.Eligible,
    expenseCategory: "other"
  };
  confirmPaid = false;

  onConfirmPaid () {
    this.confirmPaid = true;
  }

  onConfirmUnpaid () {
    this.confirmPaid = false;
  }

  handleSubmit () {
    this.$parent.$emit("close-add-expense");
  }
}

